import { render, staticRenderFns } from "./Filter-user.vue?vue&type=template&id=baf6ea8a"
import script from "./Filter-user.vue?vue&type=script&lang=js"
export * from "./Filter-user.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports